// extracted by mini-css-extract-plugin
export var clearIcon = "fP_mv";
export var dropdown = "fP_kd";
export var hasClearIcon = "fP_mt";
export var open = "fP_jY";
export var small = "fP_b1";